import React from "react";
import { useContext } from "../../../../../context";
import { NOTIFICATION_TYPE } from "../../../../../config";

export function SelectType({ value, onChange }) {
  const { appointment } = useContext();

  return (
    <div className="row">
      <div className="col-xs-12">
        <div className="simpleField">
          <div className="simpleLabel">
            {`${appointment.patient.fullName} will be notified via:`}
          </div>
          <select
            className="simpleSelect"
            onChange={(e) => onChange(e.target.value)}
            value={value}
          >
            <option value={NOTIFICATION_TYPE.email}>Email</option>
            <option value={NOTIFICATION_TYPE.sms}>SMS </option>
            <option value={NOTIFICATION_TYPE.emailAndSms}>
              {"Email & SMS Both"}
            </option>
            <option value={NOTIFICATION_TYPE.dontSend}>
              {"Don't Send Notification"}
            </option>
          </select>
        </div>
      </div>
    </div>
  );
}
